'use client'

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material'
import React from 'react'
import { useTranslations } from 'next-intl'

interface FareRulesTableProps {
    airlineCancellationFee: string
    flyinCancellationFee: string
    airlineDateChangeFee: string
    flyinDateChangeFee: string
}

const FareRulesTable: React.FC<FareRulesTableProps> = ({
    airlineCancellationFee,
    flyinCancellationFee,
    airlineDateChangeFee,
    flyinDateChangeFee
}) => {
    const t = useTranslations('srpFlightDetails')

    const headingCellSx = {
        fontWeight: 600,
        color: '#374151',
        borderRight: '1px solid #E0E0E0'
    }

    const labelCellSx = {
        borderRight: '1px solid #E0E0E0',
        color: '#111827'
    }

    const valueCellSx = {
        color: '#111827'
    }

    return (
        <TableContainer
            component={Paper}
            sx={{
                border: '1px solid #E0E0E0',
                borderRadius: 2,
                overflow: 'hidden',
                boxShadow: 'none'
            }}
        >
            <Table>
                <TableHead>
                    <TableRow sx={{ backgroundColor: '#F9FAFB' }}>
                        <TableCell sx={headingCellSx} />
                        <TableCell sx={headingCellSx}>{t('airlineFee')}</TableCell>
                        <TableCell sx={{ ...headingCellSx, borderRight: 'none' }}>{t('flyinFee')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell sx={labelCellSx}>{t('cancellation')}</TableCell>
                        <TableCell sx={labelCellSx}>{airlineCancellationFee}</TableCell>
                        <TableCell sx={valueCellSx}>{flyinCancellationFee}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell sx={labelCellSx}>{t('dateChange')}</TableCell>
                        <TableCell sx={labelCellSx}>{airlineDateChangeFee}</TableCell>
                        <TableCell sx={valueCellSx}>{flyinDateChangeFee}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default FareRulesTable